export default __webpack_public_path__ + "static/calzon-nocturno-1ab827f0b27dcdda3929bc0a50ca445b.png";